export function formatShallow(src) {
  const out = {};

  for (const key in src) {
    const value = src[key];
    const type = typeof value;
    if (value === null) out[key] = null;
    else if (Array.isArray(value)) out[key] = `Array(${value.length})`;
    else if (value instanceof Map) out[key] = `Map(${value.size})`;
    else if (value instanceof Set) out[key] = `Set(${value.size})`;
    else if (type === 'string') out[key] = value;
    else if (type === 'object')
      out[key] = `Object(${Object.keys(value).length})`;
    else out[key] = value;
  }

  return out;
}
